import { render, staticRenderFns } from "./OutStockOrderDetail.vue?vue&type=template&id=42ca1d1f&"
import script from "./OutStockOrderDetail.vue?vue&type=script&lang=js&"
export * from "./OutStockOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports